import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      {/* Main navigation */}
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_domus-co-interieur/artifacts/phw3jo81_IMG_2623.jpeg" 
              alt="Domus & Co" 
              className="h-16 w-auto object-contain cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            />
            <div className="cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              <h1 className={`text-2xl font-bold transition-colors ${
                isScrolled ? 'text-[#0B1F3C]' : 'text-white'
              }`}>
                DOMUS & CO
              </h1>
              <p className={`text-xs transition-colors ${
                isScrolled ? 'text-[#c9a961]' : 'text-[#c9a961]'
              }`}>
                L'expert de la rénovation
              </p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('accueil')}
              className={`font-medium transition-colors hover:text-[#c9a961] ${
                isScrolled ? 'text-[#0B1F3C]' : 'text-white'
              }`}
            >
              Accueil
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`font-medium transition-colors hover:text-[#c9a961] ${
                isScrolled ? 'text-[#0B1F3C]' : 'text-white'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('realisations')}
              className={`font-medium transition-colors hover:text-[#c9a961] ${
                isScrolled ? 'text-[#0B1F3C]' : 'text-white'
              }`}
            >
              Réalisations
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#c9a961] hover:bg-[#b89951] text-white font-medium px-6"
            >
              Devis Gratuit
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X size={24} className={isScrolled ? 'text-[#0B1F3C]' : 'text-white'} />
            ) : (
              <Menu size={24} className={isScrolled ? 'text-[#0B1F3C]' : 'text-white'} />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 py-4 bg-white rounded-lg shadow-xl">
            <div className="flex flex-col gap-4 px-4">
              <button
                onClick={() => scrollToSection('accueil')}
                className="text-[#0B1F3C] font-medium hover:text-[#c9a961] transition-colors text-left py-2"
              >
                Accueil
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="text-[#0B1F3C] font-medium hover:text-[#c9a961] transition-colors text-left py-2"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('realisations')}
                className="text-[#0B1F3C] font-medium hover:text-[#c9a961] transition-colors text-left py-2"
              >
                Réalisations
              </button>
              <Button
                onClick={() => scrollToSection('contact')}
                className="bg-[#c9a961] hover:bg-[#b89951] text-white font-medium w-full"
              >
                Devis Gratuit
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
